import React from 'react';
import type { FormFieldProps as SemanticFieldProps } from 'semantic-ui-react';

import type { FormFieldProps } from '../FormField/FormField';
import { FormField } from '../FormField/FormField';

import type { RawToggleProps, RawToggleValueType } from './RawToggle';
import { RawToggle } from './RawToggle';

export type ToggleProps<FormValue> = {
  description?: FormFieldProps<FormValue>['description'];
  disabled?: RawToggleProps['disabled'];
  id?: RawToggleProps['id'];
  label?: FormFieldProps<FormValue>['label'];
  name: RawToggleProps['name'];
  onChange?: RawToggleProps['onChange'];
  variation?: 'default' | 'minimal';
};

export const Toggle = <FormValue,>({
  description,
  disabled = false,
  variation = 'default',
  id,
  label,
  name,
  onChange,
}: ToggleProps<FormValue>) => {
  const formattedId = id || name;
  return (
    <FormField
      {...{
        dataTest: name,
        description,
        disabled,
        id: formattedId,
        label,
        name,
      }}
      renderField={({
        value,
        setFieldValue,
        setFieldTouched,
      }: { value: RawToggleValueType } & SemanticFieldProps) => (
        <RawToggle
          variation={variation}
          disabled={disabled}
          id={formattedId}
          name={name}
          onChange={v => {
            setFieldTouched(name);
            void onChange?.(v);
            setFieldValue(name, v);
          }}
          value={value}
        />
      )}
    />
  );
};
